var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/hooks/useLibreCaregiver.tsx";
import React, { useCallback } from 'react';
import { Stack, Text } from '@adc/parallax-component-library';
import { CLOSE_MODAL, SHOW_MODAL } from 'Reducers/modal/types';
import i18n from 'Utilities/i18n';
import { store } from 'Utilities/store';
import { deleteCaregiverConnectionService, deleteCaregiverInvitationService, getConnectionsService, inviteCaregiverService, resendCaregiverInviteService } from 'Services/libre_api';
const useLibreCaregiver = () => {
  const removeCaregiverConnection = useCallback(async caregiverConnection => {
    return deleteCaregiverConnectionService(caregiverConnection.caregiverId);
  }, []);
  const removeCaregiverInvitation = useCallback(async caregiverInvitation => {
    const {
      invitationId
    } = caregiverInvitation;
    await deleteCaregiverInvitationService(invitationId);
  }, []);
  const resendCaregiverInvite = useCallback(async caregiverInvitation => {
    await resendCaregiverInviteService(caregiverInvitation.invitationId);
  }, []);
  const inviteCaregiver = useCallback(async (firstName, lastName, email) => {
    try {
      const {
        invitationId
      } = await inviteCaregiverService({
        email,
        firstName,
        lastName
      });
      const {
        caregiverInvitations
      } = await getConnectionsService();
      const caregiverInvitation = caregiverInvitations?.find(caregiverInvitation => caregiverInvitation.invitationId === invitationId);
      return {
        caregiverInvitation
      };
    } catch (err) {
      const error = err;
      const errorCode = error.response?.data.code;
      return {
        errorCode
      };
    }
  }, []);
  const showRemoveInvitationConfirmationModal = useCallback(onRemoveClick => {
    store.dispatch({
      type: SHOW_MODAL,
      modalProps: {
        buttonLayout: 'column',
        details: /*#__PURE__*/React.createElement(Stack, {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 81,
            columnNumber: 11
          }
        }, /*#__PURE__*/React.createElement(Text, {
          color: "$text.100",
          fontWeight: "$bodyBase.strong",
          fontSize: "$bodyBase.strong",
          testID: "RemoveConnectionModal.title",
          marginBottom: "$4",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 82,
            columnNumber: 13
          }
        }, i18n.t('Global.modals.removeConnection.title')), /*#__PURE__*/React.createElement(Text, {
          color: "$text.100",
          fontWeight: "$bodyBase.default",
          fontSize: "$bodyBase.default",
          testID: "RemoveConnectionModal.body",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 91,
            columnNumber: 13
          }
        }, i18n.t('Global.modals.removeConnection.body'))),
        primaryAction: {
          label: i18n.t('Global.microcopy.common.removeCap'),
          destructive: true,
          onPress: () => {
            store.dispatch({
              type: CLOSE_MODAL
            });
            onRemoveClick();
          }
        },
        secondaryAction: {
          label: i18n.t('Global.microcopy.common.cancel'),
          onPress: () => store.dispatch({
            type: CLOSE_MODAL
          })
        },
        testID: 'RemoveConnectionModal'
      }
    });
  }, []);
  const showStopSharingModal = useCallback(onRemoveClick => {
    store.dispatch({
      type: SHOW_MODAL,
      modalProps: {
        buttonLayout: 'column',
        details: /*#__PURE__*/React.createElement(Stack, {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 129,
            columnNumber: 11
          }
        }, /*#__PURE__*/React.createElement(Text, {
          color: "$text.100",
          fontWeight: "$bodyBase.strong",
          fontSize: "$bodyBase.strong",
          testID: "StopSharingModal.title",
          marginBottom: "$4",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 130,
            columnNumber: 13
          }
        }, i18n.t('Global.modals.stopSharing.title')), /*#__PURE__*/React.createElement(Text, {
          color: "$text.100",
          fontWeight: "$bodyBase.default",
          fontSize: "$bodyBase.default",
          testID: "StopSharingModal.body",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 139,
            columnNumber: 13
          }
        }, i18n.t('Global.modals.stopSharing.body'))),
        primaryAction: {
          label: i18n.t('Global.modals.stopSharing.title'),
          destructive: true,
          onPress: () => {
            store.dispatch({
              type: CLOSE_MODAL
            });
            onRemoveClick();
          }
        },
        secondaryAction: {
          label: i18n.t('Global.microcopy.common.cancel'),
          onPress: () => store.dispatch({
            type: CLOSE_MODAL
          })
        },
        testID: 'StopSharingModal'
      }
    });
  }, []);
  return {
    inviteCaregiver,
    resendCaregiverInvite,
    removeCaregiverConnection,
    removeCaregiverInvitation,
    showRemoveInvitationConfirmationModal,
    showStopSharingModal
  };
};
export default useLibreCaregiver;